/* ============================================================
   DAYATECH DY-368 PDP — redesign interactions (.rp-* namespace)
   图廊切换 · 整屏轮播 (3000ms 自动播 · 无限循环) · 折叠栏互斥
   双 tab 切换 · 评价 SHOW MORE · Helpful +1 · 筛选 chip 态
   规格源: deliverables/pm/new-module-pdp-redesign-368-plan-20260610.md
   ============================================================ */
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- B1 · gallery (横向滑动切换 + 箭头循环 + 自动轮播 · 与下方宽幅轮播同款) ----------
     - 切换形式改为 track + transform 横向平移 (slide 0.7s · 与 rp-carousel 同机制) · 不再瞬时换 src
     - 无限循环: 克隆首张追加尾部 · 到克隆位瞬时归零 (is-instant)
     - 自动播 3000ms (与下方宽幅轮播节奏一致) · 缩略图点击 = 直跳对应 index · active 同步高亮
     - 手动操作 (点箭头 / 点缩略图 / 触屏横滑) 后重置计时器 · 避免刚点完就被自动跳走
     - prefers-reduced-motion 停自动播 · tab 切走暂停 · 回来恢复 · 张数自适应 (6/7 张) */
  var galTrack = document.getElementById('rpGalTrack');
  var thumbs = [].slice.call(document.querySelectorAll('.rp-gallery__thumb'));
  if (galTrack && thumbs.length) {
    var galReal = galTrack.children.length; // 真实张数 (6 / 7)
    var galClone = galTrack.children[0].cloneNode(true);
    galClone.setAttribute('aria-hidden', 'true');
    galTrack.appendChild(galClone);

    var galIndex = 0; // 0..galReal (galReal = 克隆位)
    var galInterval = (navigator.deviceMemory && navigator.deviceMemory < 4) ? 5000 : 3000;
    var galTimer = null;

    var galApply = function (instant) {
      galTrack.classList.toggle('is-instant', !!instant);
      galTrack.style.transform = 'translateX(' + (-galIndex * 100) + '%)';
      if (instant) {
        void galTrack.offsetWidth; // 强制 reflow · 让 is-instant 摘除后过渡恢复
        galTrack.classList.remove('is-instant');
      }
    };
    var galPaintThumbs = function () {
      var logical = galIndex % galReal;
      thumbs.forEach(function (b, idx) {
        var active = idx === logical;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };
    var galGoTo = function (i) {
      if (i > galReal) i = galReal;
      if (i < 0) {
        // 从首张往前: 瞬移到克隆位再滑回真实末张
        galIndex = galReal;
        galApply(true);
        galIndex = galReal - 1;
        galApply(false);
        galPaintThumbs();
        return;
      }
      galIndex = i;
      galApply(false);
      galPaintThumbs();
    };

    galTrack.addEventListener('transitionend', function (e) {
      if (e.target !== galTrack) return;
      if (galIndex === galReal) {
        galIndex = 0;
        galApply(true);
        galPaintThumbs();
      }
    });

    var galStop = function () {
      if (galTimer) { clearInterval(galTimer); galTimer = null; }
    };
    var galStart = function () {
      if (prefersReducedMotion || galTimer || galReal < 2) return;
      galTimer = setInterval(function () { galGoTo(galIndex + 1); }, galInterval);
    };
    var galRestart = function () { galStop(); galStart(); };

    thumbs.forEach(function (btn, idx) {
      btn.addEventListener('click', function () { galGoTo(idx); galRestart(); });
    });
    var galPrev = document.getElementById('rpGalPrev');
    var galNext = document.getElementById('rpGalNext');
    if (galPrev) galPrev.addEventListener('click', function () { galGoTo(galIndex - 1); galRestart(); });
    if (galNext) galNext.addEventListener('click', function () { galGoTo(galIndex + 1); galRestart(); });

    // 触屏横滑 (≤768 箭头隐藏后的切换方式 · 与 rp-carousel 同款)
    var galTouchX = null;
    galTrack.addEventListener('touchstart', function (e) {
      galTouchX = e.touches[0].clientX;
    }, { passive: true });
    galTrack.addEventListener('touchend', function (e) {
      if (galTouchX === null) return;
      var dx = e.changedTouches[0].clientX - galTouchX;
      galTouchX = null;
      if (Math.abs(dx) < 40) return;
      galGoTo(galIndex + (dx < 0 ? 1 : -1));
      galRestart();
    }, { passive: true });

    // tab 切走暂停 · 回来恢复
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) galStop();
      else galStart();
    });

    galStart();
  }

  /* ---------- B3 · 整屏宽幅轮播 ----------
     - slide 0.7s cubic-bezier(0.7,0,0.3,1) · 自动播 3000ms (deviceMemory<4 退 5000ms)
     - 无限循环: 克隆首张追加尾部 · 到克隆位瞬时归零
     - tab 切走暂停 · prefers-reduced-motion 停自动播 · 无 hover 暂停
     - ≤768 箭头隐藏 · 触屏横滑 + 圆点 */
  var carousel = document.getElementById('rpCarousel');
  var track = document.getElementById('rpCarTrack');
  if (carousel && track) {
    var realCount = track.children.length; // 4
    var clone = track.children[0].cloneNode(true);
    track.appendChild(clone);

    var carIndex = 0; // 0..realCount (realCount = 克隆位)
    var timer = null;
    var interval = (navigator.deviceMemory && navigator.deviceMemory < 4) ? 5000 : 3000;
    var dots = [].slice.call(document.querySelectorAll('.rp-carousel__dot'));

    var applyTransform = function (instant) {
      track.classList.toggle('is-instant', !!instant);
      track.style.transform = 'translateX(' + (-carIndex * 100) + '%)';
      if (instant) {
        // 强制 reflow · 让 is-instant 摘除后过渡恢复
        void track.offsetWidth;
        track.classList.remove('is-instant');
      }
    };
    var paintDots = function () {
      var logical = carIndex % realCount;
      dots.forEach(function (d, i) {
        var active = i === logical;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    };
    var goTo = function (i) {
      if (i > realCount) i = realCount;
      if (i < 0) {
        // 从首张往前: 瞬移到克隆位再滑回真实末张
        carIndex = realCount;
        applyTransform(true);
        carIndex = realCount - 1;
        applyTransform(false);
        paintDots();
        return;
      }
      carIndex = i;
      applyTransform(false);
      paintDots();
    };

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track) return;
      if (carIndex === realCount) {
        carIndex = 0;
        applyTransform(true);
        paintDots();
      }
    });

    var stop = function () {
      if (timer) { clearInterval(timer); timer = null; }
    };
    var start = function () {
      if (prefersReducedMotion || timer) return;
      timer = setInterval(function () { goTo(carIndex + 1); }, interval);
    };
    var restart = function () { stop(); start(); };

    var carPrev = document.getElementById('rpCarPrev');
    var carNext = document.getElementById('rpCarNext');
    if (carPrev) carPrev.addEventListener('click', function () { goTo(carIndex - 1); restart(); });
    if (carNext) carNext.addEventListener('click', function () { goTo(carIndex + 1); restart(); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(carIndex === realCount ? i : i); // 直跳
        restart();
      });
    });

    // 触屏横滑 (≤768 箭头隐藏后的切换方式)
    var touchX = null;
    track.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) < 40) return;
      goTo(carIndex + (dx < 0 ? 1 : -1));
      restart();
    }, { passive: true });

    // tab 切走暂停 · 回来恢复
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    start();
  }

  /* ---------- E3 · 折叠栏 (同组互斥 · 默认全收 · max-height 0.3s) ---------- */
  [].slice.call(document.querySelectorAll('[data-acc-group]')).forEach(function (group) {
    var items = [].slice.call(group.querySelectorAll('.rp-acc'));
    items.forEach(function (item) {
      var btn = item.querySelector('.rp-acc__head');
      var panel = item.querySelector('.rp-acc__panel');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var wasOpen = item.classList.contains('is-open');
        items.forEach(function (other) {
          other.classList.remove('is-open');
          other.querySelector('.rp-acc__head').setAttribute('aria-expanded', 'false');
          other.querySelector('.rp-acc__panel').style.maxHeight = '';
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    });
  });

  /* ---------- B7 · 双 tab (瞬时切换无动画) ---------- */
  var tabReviews = document.getElementById('rpTabReviews');
  var tabQuestions = document.getElementById('rpTabQuestions');
  var panelReviews = document.getElementById('rpPanelReviews');
  var panelQuestions = document.getElementById('rpPanelQuestions');
  if (tabReviews && tabQuestions && panelReviews && panelQuestions) {
    var selectTab = function (showReviews) {
      tabReviews.classList.toggle('is-active', showReviews);
      tabQuestions.classList.toggle('is-active', !showReviews);
      tabReviews.setAttribute('aria-selected', showReviews ? 'true' : 'false');
      tabQuestions.setAttribute('aria-selected', showReviews ? 'false' : 'true');
      panelReviews.hidden = !showReviews;
      panelQuestions.hidden = showReviews;
    };
    tabReviews.addEventListener('click', function () { selectTab(true); });
    tabQuestions.addEventListener('click', function () { selectTab(false); });
  }

  /* ---------- B7 · SHOW MORE (初始 5 条 · 点击追加 5 条 · 全显后按钮消失) ---------- */
  var moreBtn = document.getElementById('rpShowMore');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var hidden = [].slice.call(document.querySelectorAll('.rp-review.is-hidden'));
      hidden.slice(0, 5).forEach(function (card) { card.classList.remove('is-hidden'); });
      if (document.querySelectorAll('.rp-review.is-hidden').length === 0) {
        moreBtn.classList.add('is-done');
      }
    });
  }

  /* ---------- B7 · Helpful +1 (每卡一次) ---------- */
  [].slice.call(document.querySelectorAll('.rp-review__helpful')).forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.dataset.voted) return;
      btn.dataset.voted = '1';
      var node = btn.lastChild; // 文本节点 "Helpful (n)"
      var m = /Helpful \((\d+)\)/.exec(node.textContent);
      if (m) node.textContent = 'Helpful (' + (parseInt(m[1], 10) + 1) + ')';
    });
  });

  /* ---------- B7 · 评价筛选 (chip 标签 + 评分分布条 · 通用 · 读 data 属性驱动) ----------
     - chip 点击:切视觉态(is-active/aria-pressed) + 调 applyReviewFilter('tag', data-tag)
     - 分布条行点击:切高亮态(is-active) + 调 applyReviewFilter('rating', data-rating)
     - applyReviewFilter 只认 .rp-review 的 data-tags / data-rating 属性 · 不硬编码任何具体标签词
       (4 款 PDP 共用本文件 · 各自 chip 文案不同 · 靠 HTML 属性驱动实现通用) */
  var reviewPanel = document.getElementById('rpPanelReviews');
  var reviewList = document.getElementById('rpReviewList');
  var reviewEmpty = document.querySelector('.rp-reviews__empty');

  function applyReviewFilter(mode, value) {
    if (!reviewList) return;
    var cards = [].slice.call(reviewList.querySelectorAll('.rp-review'));
    var visibleCount = 0;
    cards.forEach(function (card) {
      var match;
      if (mode === 'rating') {
        match = card.getAttribute('data-rating') === value;
      } else {
        match = value === 'all' || (card.getAttribute('data-tags') || '').split(',').indexOf(value) !== -1;
      }
      card.classList.toggle('rp-review--filtered-out', !match);
      if (match) visibleCount++;
    });

    if (reviewPanel) reviewPanel.classList.toggle('is-filtering', value !== 'all');

    if (reviewEmpty) reviewEmpty.hidden = visibleCount !== 0;
  }

  var chips = [].slice.call(document.querySelectorAll('.rp-chip--btn'));
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-pressed', 'false');
      });
      chip.classList.add('is-active');
      chip.setAttribute('aria-pressed', 'true');

      // 切回 All 时分布条高亮同步清除 (两套筛选互斥·后触发的为准)
      distRows.forEach(function (r) { r.classList.remove('is-active'); });

      applyReviewFilter('tag', chip.getAttribute('data-tag') || 'all');
    });
  });

  var distRows = [].slice.call(document.querySelectorAll('.rp-dist__row'));
  var activateDistRow = function (row) {
    distRows.forEach(function (r) { r.classList.remove('is-active'); });
    row.classList.add('is-active');
    // 分布条筛选生效时·chip 视觉态回到 All (两套筛选互斥·分布条优先本次触发)
    chips.forEach(function (c) {
      c.classList.remove('is-active');
      c.setAttribute('aria-pressed', 'false');
    });
    var allChip = document.querySelector('.rp-chip--btn[data-tag="all"]');
    if (allChip) { allChip.classList.add('is-active'); allChip.setAttribute('aria-pressed', 'true'); }
    applyReviewFilter('rating', row.getAttribute('data-rating'));
  };
  distRows.forEach(function (row) {
    row.addEventListener('click', function () { activateDistRow(row); });
    row.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        activateDistRow(row);
      }
    });
  });

  /* ---------- E1 · ADD TO CART → 真实加购（window.DTCart）----------
     批次 B（task T2 · 2026-06-12）：静态原型的 console 占位升级为真加购。
     · variant id 从按钮 data-variant-id 读（Liquid 渲染真实 id · JS 不硬编码 · 4 款 rp PDP 通用）。
     · 加购成功 → cart.js 自动广播 cart:updated（刷角标）+ cart:open（弹抽屉）· 本处只管按钮态。
     · 失败必给用户可见英文提示（不静默 console）：在按钮下方渲染 .rp-atc-error（红字）。
     依赖：cart.js（theme.liquid 全局 defer 加载 · 早于本脚本）。 */
  var atc = document.getElementById('rpAtc');
  if (atc) {
    // 错误提示元素：懒创建一次 · 插在按钮后（紧贴 ATC · 不依赖 section 额外 DOM）
    var atcErr = null;
    function showAtcError(msg) {
      if (!atcErr) {
        atcErr = document.createElement('p');
        atcErr.className = 'rp-atc-error';
        atcErr.setAttribute('role', 'alert');
        atc.parentNode.insertBefore(atcErr, atc.nextSibling);
      }
      atcErr.textContent = msg;
      atcErr.classList.add('is-shown');
    }
    function clearAtcError() {
      if (atcErr) atcErr.classList.remove('is-shown');
    }

    atc.addEventListener('click', function () {
      clearAtcError();
      if (!window.DTCart || typeof window.DTCart.add !== 'function') {
        showAtcError('Cart is unavailable right now. Please refresh and try again.');
        return;
      }
      var variantId = atc.getAttribute('data-variant-id');
      if (!variantId) {
        showAtcError('Could not identify this product. Please refresh and try again.');
        return;
      }
      var original = atc.textContent;
      atc.disabled = true;
      atc.textContent = 'Adding…';
      // clear any lingering success timeout from a previous rapid click
      if (atc._successTimer) { clearTimeout(atc._successTimer); atc.classList.remove('rp-atc--success'); }
      window.DTCart.add({ id: variantId, quantity: 1 })
        .then(function () {
          atc.textContent = '✓ Added';   // ✓ checkmark feedback
          atc.classList.add('rp-atc--success');
          atc.disabled = false;
          atc._successTimer = setTimeout(function () {
            atc.textContent = original;
            atc.classList.remove('rp-atc--success');
            atc._successTimer = null;
          }, 1500);
        })
        .catch(function (err) {
          atc.textContent = original;
          atc.disabled = false;
          var emsg = (err && (err.description || err.message)) || '';
          if (/sold out|stock|inventory|not available|unavailable/i.test(emsg) ||
              (err && err.status === 422)) {
            showAtcError('Sorry, this item is currently sold out.');
          } else {
            showAtcError('Could not add to cart. Check your connection and try again.');
          }
          console.error('[rp-atc] add failed:', err);
        });
    });
  }

  /* ---------- Sticky Add-to-Cart Bar (mobile) ----------
     Show .rp-sticky-bar when buybox scrolls out of viewport.
     Uses IntersectionObserver on #purchase (buybox anchor).
     Desktop hidden via CSS (display:none at >768px). */
  var stickyBar = document.getElementById('rpStickyBar');
  var purchaseAnchor = document.getElementById('purchase');
  if (stickyBar && purchaseAnchor && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-shown', !entry.isIntersecting);
      });
    }, { threshold: 0, rootMargin: '0px 0px -80px 0px' });
    stickyObserver.observe(purchaseAnchor);
  }

  /* ---------- Gallery hover pause ----------
     Pause carousel auto-rotation when hovering over the gallery stage.
     Resume on mouse leave. Gated by prefers-reduced-motion. */
  (function () {
    var stage = document.querySelector('.rp-gallery__stage');
    if (stage && typeof galStop === 'function' && typeof galStart === 'function' && !prefersReducedMotion) {
      stage.addEventListener('mouseenter', function () { galStop(); });
      stage.addEventListener('mouseleave', function () { galStart(); });
    }
  })();

})();
